import React, { useEffect } from 'react';
import { t } from './i18n';
import { legal } from './legal';

// Textul legal traieste intr-un singur loc, pe newmind.ro (20 septembrie 2026). Pana azi exista si
// aici, scris separat in aprilie, iar cele doua copii s-au departat una de alta fara sa bage nimeni
// de seama cinci luni si jumatate. Rutele raman, ca sa nu se strice niciun link din ecranul de
// intrare, din consimtamant, din bannerul de cookies sau din panourile Meta si TikTok; doar ca
// acum duc la textul bun. `legal()` alege singura ancora `#english` cand ecranul e pe engleza.
export default function RedirectLegal({ care }) {
  const adresa = legal(care);

  useEffect(() => { window.location.replace(adresa); }, [adresa]);

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 24px', fontFamily: "'DM Sans', sans-serif", color: '#1F2937', lineHeight: 1.8 }}>
      <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 28, color: '#0F3D22', marginBottom: 16 }}>NM Social</div>
      <p>{t('ecraneMici', 'seDeschideTextul')}</p>
      <p><a href={adresa} style={{ color: '#1A6B3C', fontWeight: 600 }}>{t('ecraneMici', 'deschidePagina')}</a></p>
      <div style={{ marginTop: 40, paddingTop: 24, borderTop: '1px solid #E5E7EB' }}>
        <a href="/" style={{ color: '#1A6B3C', fontWeight: 600 }}>{t('ecraneMici', 'inapoiLaAplicatie')}</a>
      </div>
    </div>
  );
}
